import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head, storyblokComponents } from '@cinch-nx/landing-ui-shared'
import {
  ComponentLayouts,
  StoryblokRendererV2 as StoryblokRenderer,
} from '@cinch-nx/storyblok-utils'

import styles from './feature-brand-page.module.css'
import { BrandPageProps } from './get-static-props'
import { BrandPageStory } from './storyblok/storyblok'

export const FeatureBrandPage = ({ story, preview }: BrandPageProps) => {
  const { content } = useStoryblokState<BrandPageStory>({
    story,

    enableBridge: preview,
  })

  const SEO = content.SEO?.[0] ?? {}

  const { HighlightsSection, ...restComponents } = storyblokComponents
  const componentLayouts: ComponentLayouts = {
    fullWidthWrapper: { HighlightsSection },
    slimWrapper: restComponents,
  }

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle="Brand Page - cinch"
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
      />

      <article className={styles.pageWrapper}>
        <StoryblokRenderer block={content.body} components={componentLayouts} />
      </article>
    </>
  )
}
